import React from "react";
import { navigate } from "@reach/router";

//-------------------------------------------------------------------------
// Modern Student Card for Pensiones
//-------------------------------------------------------------------------
export default function StudentCard(props) {
  const student = props.student;
  const initials = student.nomEst
    ? student.nomEst.trim().charAt(0).toUpperCase()
    : "?";

  return (
    <div
      className="student-card-modern slide-in-up"
      onClick={() => navigate("rubros/" + student.codEst)}
    >
      <div className="student-avatar">{initials}</div>
      <div className="student-info">
        <div className="student-name">{student.nomEst}</div>
        <div className="student-meta">
          Código: <b>{student.codEst}</b> &nbsp;|&nbsp; Nivel: <b>{student.codNiv}</b>
          {student.abrCur && <>&nbsp;|&nbsp; Curso: <b>{student.abrCur}</b></>}
          {student.periodo && <>&nbsp;|&nbsp; Año: <b>{student.periodo}</b></>}
          {student.paralelo && <>&nbsp;|&nbsp; Paralelo: <b>{student.paralelo}</b></>}
        </div>
      </div>
      <div className="student-arrow">→</div>
    </div>
  );
}
